import React from "react";
import { useForm } from "react-hook-form";
import { MoneyApi } from "go-core/api/types";
import HeaderBack from "../../components/HeaderBack";
import { useParentGoBackMessage } from "../../hooks";
import CustomTipSection from "./components/CustomTipSection";
import CustomTipStickyFooter from "./components/CustomTipStickyFooter";

const EOrderCustomTipPage = () => {
	const form = useForm<{ tip: MoneyApi }>({
		criteriaMode: "all",
	});
	useParentGoBackMessage(false);

	return (
		<>
			<HeaderBack />
			<main>
				<CustomTipSection form={form} />
			</main>
			<CustomTipStickyFooter form={form} />
		</>
	);
};

export default EOrderCustomTipPage;
